import * as rcService from '/source/js/services/recommendedCartService';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';
let $shareLinkReceiveModal;

async function closeShareLinkModal() {
    $shareLinkReceiveModal.modal('hide');

    try {
        if($('#ShareCode').val()) {
            await rcService.updateShareLinkModalFlag($('#ShareCode').val());
        }
    } catch (ex) {
        console.error(ex);
    }
}

async function closeShareLinkModalAndRedirect(event) {
    event.preventDefault();
    event.stopPropagation();
    $shareLinkReceiveModal.modal('hide');
    try {
        if($('#ShareCode').val()) {
            loadSpinner();
            await rcService.updateShareLinkModalFlag($('#ShareCode').val());
            stopSpinner();
            window.location.href = $(this).attr('href');
        }
    } catch (ex) {
        console.error(ex);
        stopSpinner();
    }
}

function initEventHandlers() {
    $shareLinkReceiveModal = $('#shareLinkReceiveModal');
    if($shareLinkReceiveModal.length) {
        $shareLinkReceiveModal.modal('show');
        $shareLinkReceiveModal.on('hidden.bs.modal', closeShareLinkModal);
        $('#shareLinkReceiveModal .icon-close').on('click', closeShareLinkModal);
        $('#modalAddToCart').on('click', closeShareLinkModal);
        $('#modalShowMe').on('click', closeShareLinkModal);
        $('#showmodalMobile').on('click', closeShareLinkModal);
        $('.coming-soon_cta-list .btn__cta').on('click', closeShareLinkModalAndRedirect);
    }
}

$(function () {
    initEventHandlers();
});
